<template>
  <wizard-base
    class="living-space"
    :title="$t('WIZARD.LIVING_SPACE.TITLE')"
    :subtitle="$t('GENERAL.FIELD_REQUIRED')"
    :icon="slideIcon"
  >
    <hd-input-formatter
      v-model="livingSpace"
      name="living-space"
      type="number"
      :label="$t('GENERAL.LIVING_SPACE')"
      :formatter="$formatSpace"
      :custom-rules="customRules"
      class="living-space__input"
    />
  </wizard-base>
</template>

<script>
// @ts-check
import { toFinite as _toFinite, isNumber as _isNumber, inRange as _inRange } from 'lodash-es';

import { HdInputFormatter } from 'homeday-blocks';
import WizardBase from '@/layout/WizardBase.vue';
import { mapFeatures } from '@/services/feature';
import { houseHeart as slideIcon } from 'homeday-assets/L';
import { MINIMUM_SPACE, MAXIMUM_SPACE } from '@/config/CONSTANTS';

export default {
  name: 'LivingSpaceSlide',
  components: {
    HdInputFormatter,
    WizardBase,
  },
  data() {
    return {
      slideIcon,
    };
  },
  computed: {
    ...mapFeatures(['livingSpace']),
    /** @returns {import('@/@types/global').ValidationRules} */
    customRules() {
      return [
        {
          validate: (value) => {
            if (!_isNumber(Number(value))) return false;

            return _inRange(_toFinite(value), MINIMUM_SPACE, MAXIMUM_SPACE);
          },
          errorMessage: this.$t('FIELD_VALIDATIONS.INCORRECT_VALUE'),
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';
.living-space {
  &__input {
    width: 100%;
  }
}
</style>
